import React, { useEffect, useContext, useState } from 'react'
import { getReleaseDate } from '../../utils/helper'
import getSymbolFromCurrency from 'currency-symbol-map'
import { SubscriptionContext } from '../../context/subscription'

const TransactionDetailModal = ({ order, onClose }) => {
  let { transaction, is_complimentary = false, subscriber_subscription_id = '' } = order
  const { availableSubscription } = useContext(SubscriptionContext)
  const [subName, setSubName] = useState('')

  useEffect(() => {
    if (is_complimentary && subscriber_subscription_id) {
      let tempCurrentSubscription = [...availableSubscription].find(
        (plan) => plan._id === subscriber_subscription_id,
      )

      if (tempCurrentSubscription) {
        setSubName(tempCurrentSubscription?.name)
      }
    }
  }, [subscriber_subscription_id, is_complimentary])

  return (
    <div
      style={{ backgroundColor: '#0a0a0a90' }}
      className="fixed inset-0 flex items-center justify-center z-50"
    >
      <div
        className="rounded-[10px] w-11/12 md:w-9/12 lg:w-1/2 xl:w-[60%] p-8"
        style={{ backgroundColor: '#1d2a39' }}
      >
        {is_complimentary ? (
          <p className="text-white font-semibold text-xl mb-6 text-center">
            This Product is complimentary with your current subscription {subName}
          </p>
        ) : (
          <>
            {/* Title */}
            <p className="text-white font-semibold text-xl mb-6">Transaction Details</p>

            {/* Info Section */}
            <div className="space-y-4 text-xs">
              <div className="flex justify-between">
                <span className="text-white">Order ID</span>
                <span className="text-white">{order._id}</span>
              </div>

              <div className="flex justify-between text-xs">
                <span className="text-white">Transaction ID</span>
                <span className="text-white break-all">{transaction._id}</span>
              </div>

              <div className="flex justify-between text-xs">
                <span className="text-white">Transaction Date</span>
                <span className="text-white">{getReleaseDate(order.created_date)}</span>
              </div>

              <div className="flex justify-between text-xs">
                <span className="text-white">Payment Gateway</span>
                <div className="px-9 rounded text-sm bg-white">stripe</div>
              </div>
            </div>

            <p className="text-white font-semibold text-xs mt-5">Order Details</p>
            <hr className="border-gray-600 my-2" />
            <div className="space-y-3 text-sm">
              <div className="flex justify-between text-xs" style={{ color: '#b5b5b5' }}>
                <span>Item(s) Subtotal</span>
                <span>
                  {parseFloat(order.total_amount).toFixed(2)}{' '}
                  <span className="uppercase">{getSymbolFromCurrency(order.currency)}</span>
                </span>
              </div>

              <div className="flex justify-between text-xs mt-3" style={{ color: '#b5b5b5' }}>
                <span>Total Discount</span>
                <span>
                  - {parseFloat(order.total_discount).toFixed(2)}{' '}
                  <span className="uppercase">{getSymbolFromCurrency(order.currency)}</span>
                </span>
              </div>
              {order?.shipping_charges ? (
                <div className="flex justify-between text-xs mt-3" style={{ color: '#b5b5b5' }}>
                  <span> Shipping Charges</span>
                  <span>
                    + {parseFloat(order?.shipping_charges).toFixed(2)}{' '}
                    <span className="uppercase">{getSymbolFromCurrency(order.currency)}</span>
                  </span>
                </div>
              ) : null}
            </div>

            {/* Divider */}
            <hr className="border-gray-600 my-6" />

            {/* Final Amount */}
            <div className="flex justify-between text-xs font-semibold">
              <span className="text-white">Total Amount Paid</span>
              <span className="text-white">
                {parseFloat(order.total_payable).toFixed(2)}{' '}
                <span className="uppercase">{getSymbolFromCurrency(order.currency)}</span>
              </span>
            </div>
          </>
        )}

        {/* Action */}
        <div className="flex justify-center mt-8">
          <button
            onClick={onClose}
            className="px-14 py-2 rounded-lg font-medium  text-white"
            style={{ backgroundColor: '#f60' }}
          >
            Ok
          </button>
        </div>
      </div>
    </div>
  )
}

export default TransactionDetailModal
